import React, { useState } from 'react'
import Loadable from '../../../components/loadable/Loadable'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import Label from '../../../components/label/Label'
import Button from '../../../components/button/Button'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Checkbox from '../../../components/checkbox/basecheckbox/Checkbox'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'
import { Theme } from '../../../components/constants'
import { BUTTON_TYPE } from '../../../components/button/constants'
import TextInput from '../../../components/input/textinput/TextInput'
import { componentKey, setPermissions, setThresholdAmount, setDisabledPermissions, setRightsLabels } from './RightsManagementSlice'
import { getDisabledPermissions, getPermissions, getRightsLabels, getThresholdAmount, updatePermissions, updateThresholdAmount } from './RightsManagementSaga'
import styles from './RightsManagement.styles'
import Rights from '../../../../libs/utility/Rights'
import { ShowForAllowedPermissionsOnly } from '../../wrappers/ShowForAllowedPermissionsOnly'
import { PAGE_PATH, PAGE_PERMISSIONS } from '../../dashboard/constants/constant'
import { PermissionReroute, isAccessAllowed, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks'
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP, USER_SECTION_ROUTES } from '../../constants/constants'
import { USER_TYPE } from '../../../../libs/customhooks/constants'
import { useUserTypeInfo } from '../../../../libs/customhooks/useUserTypeInfo'
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook'
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs'

export default function RightsManagement() {
    useGarbageCollector(componentKey);
    const {loadingState, thresholdAmount, permissions, rightsLabels, disabledPermissions } = useSelector((state) => state[componentKey])
    const [reload, setReload] = useState(false);
    const dispatch = useDispatch();
    const UserPermissions = useUserPermissionsInfo();
    const navigate = useTxNavigate()
    const { userType } = useUserTypeInfo();

    useEffect(()=>{
        dispatch(getPermissions())
        dispatch(getRightsLabels())
        dispatch(getThresholdAmount())
        dispatch(getDisabledPermissions())
    },[reload])

    const peopleIndexes = [4,5,6,7,9,10,11,12,14,15,16,17]
    const payersIndexes = [4,5,6,7]
    const recipientIndexes = [9,10,11,12]
    const usersIndexes = [14,15,16,17]
    const tinIndexes = [19,20]
    const formIndexes = [24,25,26,27]

    const isChecked = ({index = undefined, rightUserType = undefined}) => {
        let result = true;
        if(index === '1') {
            permissions.forEach(perm =>{
                if(perm.RID?.includes(rightUserType) ) {
                    if(perm.RValue === false) {
                        result = false
                        return;
                    }
                }
            })
            return result
        } else if (index === '2') {
            return Rights.isChecked(peopleIndexes, rightUserType, permissions)
        } else if (index === '3') {
            return Rights.isChecked(payersIndexes, rightUserType, permissions)
        } else if (index === '8') {
            return Rights.isChecked(recipientIndexes, rightUserType, permissions)
        } else if (index === '13') {
            return Rights.isChecked(usersIndexes, rightUserType, permissions)
        } else if (index === '18') {
            return Rights.isChecked(tinIndexes, rightUserType, permissions)
        } else if (index === '23') {
            return Rights.isChecked(formIndexes, rightUserType, permissions)
        }
        if(rightUserType === undefined) {
            const nonKeyPermission = permissions.find((per) => per.RID === "")
            if(nonKeyPermission) {
                return nonKeyPermission[index]
            }
        }
        const disabledPerm = disabledPermissions.find((per) => per.Key === `${index}${rightUserType}`)
        if(disabledPerm) {
            return disabledPerm.Role;
        }
        const permission = permissions.find((per) => per.RID === `${index}${rightUserType}`)
        if(permission) {
            return permission.RValue;
        }
        return false;
    }

    const handleCheck = ({index = undefined, rightUserType = undefined, checked = undefined}) => {
        let updatedState;
        if(index === '1') {
            updatedState = permissions.map(obj => {
                if(obj?.RID?.includes(rightUserType)) {
                    return {...obj, RValue: checked}
                }
                return obj;
            });
        } else if (index === '2') {
            updatedState = Rights.handleCheck(peopleIndexes, permissions, checked, rightUserType)
        } else if (index === '3') {
            updatedState = Rights.handleCheck(payersIndexes, permissions, checked, rightUserType)
        } else if (index === '8') {
            updatedState = Rights.handleCheck(recipientIndexes, permissions, checked, rightUserType)
        } else if (index === '13') {
            updatedState = Rights.handleCheck(usersIndexes, permissions, checked, rightUserType)
        } else if (index === '18') {
            updatedState = Rights.handleCheck(tinIndexes, permissions, checked, rightUserType)
        }  else if (index === '23') {
            updatedState = Rights.handleCheck(formIndexes, permissions, checked, rightUserType)
        }
        if(updatedState) {
            dispatch(setPermissions(updatedState))
            return;
        }

        if(rightUserType === undefined) {
            updatedState = permissions.map(obj => {
                const nonKeyPermission = permissions.find((per) => per.RID === "")
                if(nonKeyPermission) {
                    return {...obj, [index]: checked}
                }
                return obj;
              });
        } else {
            updatedState = permissions.map(obj => {
                if (obj.RID === `${index}${rightUserType}`) {
                  return { ...obj, RValue: checked };
                }
                return obj;
              });
            }
        dispatch(setPermissions(updatedState))
    }

    const isDisabled = ({index= undefined, rightUserType= undefined}) => {
        if( userType === USER_TYPE.MEMBER_USER || (Object.keys(UserPermissions?.permissions ?? {}).length > 0 && !isAccessAllowed(PAGE_PERMISSIONS.CREATE_USER, UserPermissions.permissions))){
            return true;
        }
        
        if(rightUserType === undefined){
            const perm = disabledPermissions.find((perm=> perm.key === index))
            if(perm) {
                return true
            }
            return false
        }
        const permission = disabledPermissions.find((perm) => perm.Key === `${index}${rightUserType}`)
        if(permission) {
            return true
        }
        return false;
    }
    
    const handleSave = () => {
        dispatch(updatePermissions(permissions.map(permission => {
            if(permission.RID === ""){
                return {RID: "", ...permission}
            }
            return permission
        })))
    }

    useEffect(()=>{
        PermissionReroute(PAGE_PERMISSIONS.VIEW_USER, UserPermissions.permissions, navigate, PAGE_PATH.DASHBOARD)
    },[UserPermissions.permissions])

  return (

        <div style={styles.mainContainer}>
            <Breadcrumbs items={[
                    { text: 'Home', link: '/' },
                    { text: 'Manage Users', link: `/${USER_SECTION_ROUTES.USERS}/${USER_SECTION_ROUTES.MANAGE_USERS}` },
                    { text: 'Rights Management' },
                ]} 
            />
            <Heading type={HEADING.H1}>Rights Management</Heading>

            <div style={styles.checkboxDiv}>
                <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Allow Member users to use prepay balance of Master Admin</Label>
                <Checkbox checked={isChecked({ index: "prePay"})} disabled={isDisabled({index: "prePay"})} onChangeCb={(e)=> handleCheck({index: "prePay", rightUserType: undefined, checked: e.target.checked})} />
            </div>

            <div style={styles.checkboxDiv}>
                <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Allow Admin Member users to add prepay balance to Master Admin</Label>
                <Checkbox checked={isChecked({ index: "AddPrePay"})} disabled={isDisabled({index: "AddPrePay"})} onChangeCb={(e)=> handleCheck({index: "AddPrePay", rightUserType: undefined, checked: e.target.checked})} />
            </div>

            <div style={styles.checkboxDiv}>
                <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>Notify when prepay balance is below threshold $</Label>
                <div style={{width: '10%'}}>
                    <TextInput 
                        type='number'
                        name={'thresholdAmount'}
                        value={thresholdAmount}
                        onChangeCb={(e)=> dispatch(setThresholdAmount(e.target.value))}
                    />
                </div>
                <Button type={BUTTON_TYPE.PRIMARY} style={styles.buttonPadding} onClickCb={()=> { dispatch(updateThresholdAmount(thresholdAmount))}}>Set threshold Amount</Button>
            </div>
            <Loadable currentState={loadingState.state} loadingStates={COMMON_LOADING_STATES.GRID_LOADING} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true}>
                { Object.keys(rightsLabels).length > 0 &&
                    <div style={styles.rightsTable}>
                        <div style={styles.rightsTableRow}>
                            <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, ...styles.flexOne }}></Label>
                            <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, ...styles.flexOne }}>Admin</Label>
                            <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, ...styles.flexOne }}>Reviewer</Label>
                            <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, ...styles.flexOne }}>Data Entry User</Label>
                            <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, ...styles.flexOne }}>Custom User</Label>
                        </div>

                        {rightsLabels.map(right => {
                        return <div style={styles.rightsTableRow}>
                            <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text, ...styles.flexOne }}>{right.Value}</Label>
                            <div style={styles.flexOne}>
                                <Checkbox checked={isChecked({index: right.Key, rightUserType: "A"})} disabled={isDisabled({index: right.Key, rightUserType: "A"})} onChangeCb={(e)=> handleCheck({index: right.Key, rightUserType: "A", checked: e.target.checked})}/>
                            </div>
                            <div style={styles.flexOne}>
                                <Checkbox checked={isChecked({index: right.Key, rightUserType: "R"})} disabled={isDisabled({index: right.Key, rightUserType: "R"})} onChangeCb={(e)=> handleCheck({index: right.Key, rightUserType: "R", checked: e.target.checked})}/>
                            </div>
                            <div style={styles.flexOne}>
                                <Checkbox checked={isChecked({index: right.Key, rightUserType: "D"})} disabled={isDisabled({index: right.Key, rightUserType: "D"})} onChangeCb={(e)=> handleCheck({index: right.Key, rightUserType: "D", checked: e.target.checked})}/>
                            </div>
                            <div style={styles.flexOne}>
                                <Checkbox checked={isChecked({index: right.Key, rightUserType: "C"})} disabled={isDisabled({index: right.Key, rightUserType: "C"})} onChangeCb={(e)=> handleCheck({index: right.Key, rightUserType: "C", checked: e.target.checked})}/>
                            </div>
                        </div>
                        })}
                    </div>
                }
            </Loadable>
            <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.CREATE_USER}>
                <div style={styles.buttonsRow}>
                    <Button type={BUTTON_TYPE.PRIMARY} style={styles.buttonPadding} onClickCb={handleSave}>Save Permissions</Button>
                    <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={styles.buttonPadding} onClickCb={() => setReload((prev)=> !prev)}>Cancel</Button>
                </div>
            </ShowForAllowedPermissionsOnly>
        </div>
  )
}
